<app-page-layout 
  [title]="title"
  [subtitle]="subtitle"
  [heroImage]="heroImage"
  [breadcrumbs]="breadcrumbs"
  [prevPage]="prevPage"
  [nextPage]="nextPage">
  
  <div class="content-section">
    <h2>Assurance Marchandises Transportées</h2>
    <p>
      Si vous êtes à la recherche de ce type d'<strong>assurance Marchandises Transportées</strong>, merci de prendre contact avec nous car il existe trop de déclinaisons selon votre situation personnelle.
    </p>
  </div>

  <div class="content-section bg-light">
    <h2>Protection complète de vos marchandises</h2>
    <p>
      L'assurance marchandises transportées couvre vos biens pendant leur acheminement, que ce soit par voie terrestre, maritime, aérienne ou fluviale.
    </p>
    <p>
      Cette assurance est essentielle pour les entreprises qui expédient ou reçoivent régulièrement des marchandises, qu'il s'agisse de matières premières, de produits finis ou de biens commerciaux.
    </p>
  </div>

  <div class="content-section">
    <h2>Les risques couverts</h2>
    <p>
      L'assurance marchandises transportées protège contre de nombreux risques durant le transport :
    </p>
    <ul>
      <li>Accidents de transport (collision, renversement, déraillement)</li>
      <li>Vol et pillage des marchandises</li>
      <li>Incendie et explosion</li>
      <li>Dommages causés par les intempéries</li>
      <li>Chute et bris de colis</li>
      <li>Avaries communes en transport maritime</li>
      <li>Pertes et manquants à la livraison</li>
      <li>Contamination ou détérioration</li>
    </ul>
  </div>

  <div class="content-section bg-accent">
    <h2>Qui est concerné ?</h2>
    <p>
      Cette assurance s'adresse à toutes les entreprises qui transportent ou font transporter des marchandises :
    </p>
    <ul>
      <li>Importateurs et exportateurs</li>
      <li>Distributeurs et grossistes</li>
      <li>Fabricants et industriels</li>
      <li>Commerçants et détaillants</li>
      <li>E-commerçants</li>
      <li>Transporteurs pour le compte d'autrui</li>
    </ul>
    <p>
      <strong>Attention :</strong> La responsabilité du transporteur est limitée par la loi. Sans assurance marchandises transportées, vous risquez de subir des pertes importantes en cas de sinistre.
    </p>
  </div>

  <div class="content-section">
    <h2>Les différents modes de transport couverts</h2>
    
    <h3>Transport terrestre</h3>
    <p>
      Couverture des marchandises transportées par camion, train ou véhicule utilitaire sur le territoire national ou international.
    </p>

    <h3>Transport maritime</h3>
    <p>
      Protection des marchandises lors du transport par voie maritime, incluant les risques de mer spécifiques (tempête, naufrage, avarie commune).
    </p>

    <h3>Transport aérien</h3>
    <p>
      Assurance des marchandises acheminées par avion, avec des garanties adaptées aux risques du transport aérien.
    </p>

    <h3>Transport multimodal</h3>
    <p>
      Couverture continue pour les marchandises utilisant plusieurs modes de transport successifs (terre-mer-air).
    </p>
  </div>

  <div class="content-section bg-light">
    <h2>Types de contrats</h2>
    
    <h3>Police au voyage</h3>
    <p>
      Assurance ponctuelle pour un transport spécifique. Idéale pour les expéditions occasionnelles.
    </p>
    <ul>
      <li>Couverture d'un seul envoi</li>
      <li>Souscription à chaque expédition</li>
      <li>Souplesse pour les transports irréguliers</li>
    </ul>

    <h3>Police à alimenter (flottante)</h3>
    <p>
      Contrat annuel couvrant l'ensemble de vos transports. Recommandée pour les entreprises avec des expéditions régulières.
    </p>
    <ul>
      <li>Déclaration mensuelle ou trimestrielle des expéditions</li>
      <li>Gain de temps administratif</li>
      <li>Tarifs préférentiels</li>
      <li>Couverture automatique de tous les envois</li>
    </ul>

    <h3>Police tiers chargeur</h3>
    <p>
      Solution pour les commissionnaires de transport et les transitaires qui assurent les marchandises de leurs clients.
    </p>
  </div>

  <div class="content-section">
    <h2>Les garanties essentielles</h2>
    
    <h3>Garantie tous risques</h3>
    <p>
      La formule la plus complète, couvrant tous les dommages matériels sauf exclusions spécifiques.
    </p>

    <h3>Garantie FAP (Franc d'Avarie Particulière)</h3>
    <p>
      Couverture des pertes totales et des avaries communes uniquement. Solution économique pour les marchandises peu fragiles.
    </p>

    <h3>Garantie vol</h3>
    <p>
      Protection spécifique contre le vol des marchandises pendant le transport et le stationnement.
    </p>

    <h3>Extensions de garantie</h3>
    <ul>
      <li>Frais de sauvetage et de préservation</li>
      <li>Frais de dépotage et de reconditionnement</li>
      <li>Perte de poids ou de quantité</li>
      <li>Frais de réexpédition</li>
      <li>Franchise rachetée</li>
    </ul>
  </div>

  <div class="content-section bg-light">
    <h2>Valeur assurée et indemnisation</h2>
    <p>
      La valeur assurée peut être déterminée de différentes manières :
    </p>
    <ul>
      <li><strong>Valeur facture :</strong> Prix de vente des marchandises</li>
      <li><strong>Valeur CIF (Coût, Assurance, Fret) + 10% :</strong> Formule courante en commerce international</li>
      <li><strong>Valeur de remplacement :</strong> Coût de rachat des marchandises identiques</li>
      <li><strong>Valeur déclarée :</strong> Montant fixé par l'expéditeur</li>
    </ul>
    <p>
      <strong>Important :</strong> En cas de sinistre, l'indemnisation se fait généralement selon la valeur agréée au contrat, déduction faite de la franchise éventuelle.
    </p>
  </div>

  <div class="content-section">
    <h2>Obligations de l'assuré</h2>
    <p>
      Pour bénéficier pleinement de votre assurance marchandises transportées, vous devez :
    </p>
    <ul>
      <li>Emballer correctement les marchandises selon les normes du transport</li>
      <li>Respecter les conditions de transport convenues (température, délais, etc.)</li>
      <li>Déclarer avec exactitude la nature et la valeur des marchandises</li>
      <li>Prendre toutes les précautions nécessaires pour éviter les sinistres</li>
      <li>En cas de dommage, émettre des réserves auprès du transporteur</li>
      <li>Déclarer le sinistre rapidement à l'assureur (généralement sous 5 jours)</li>
      <li>Conserver les marchandises endommagées pour expertise</li>
    </ul>
  </div>

  <div class="content-section bg-accent">
    <h2>Les exclusions courantes</h2>
    <p>
      Certains risques sont généralement exclus des contrats standard :
    </p>
    <ul>
      <li>Vice propre de la marchandise (défaut inhérent au produit)</li>
      <li>Emballage insuffisant ou inadapté</li>
      <li>Retard de livraison (sans dommage matériel)</li>
      <li>Guerre et émeutes (sauf extension spécifique)</li>
      <li>Risques atomiques</li>
      <li>Faute intentionnelle de l'assuré</li>
      <li>Marchandises interdites ou non déclarées</li>
    </ul>
    <p>
      Des extensions de garantie peuvent être souscrites pour couvrir certains de ces risques.
    </p>
  </div>

  <div class="content-section">
    <h2>Pourquoi choisir Brokins pour votre assurance marchandises transportées ?</h2>
    <ul>
      <li><strong>Expertise sectorielle :</strong> Connaissance approfondie des métiers du transport et de la logistique</li>
      <li><strong>Solutions sur mesure :</strong> Contrats adaptés à votre activité et à vos flux de marchandises</li>
      <li><strong>Réseau de partenaires :</strong> Accès aux meilleurs assureurs spécialisés en transport</li>
      <li><strong>Tarifs compétitifs :</strong> Négociation des meilleures conditions tarifaires</li>
      <li><strong>Accompagnement sinistre :</strong> Assistance dans la gestion des dommages et des expertises</li>
      <li><strong>Couverture internationale :</strong> Protection de vos marchandises partout dans le monde</li>
    </ul>
  </div>

  <div class="content-section cta-section">
    <h2>Contactez-nous pour votre assurance marchandises transportées</h2>
    <p>Nos experts vous proposent une solution adaptée à vos besoins de transport</p>
    <button class="btn-primary" routerLink="/contact">Contactez-nous</button>
  </div>
</app-page-layout>
